// extracted by mini-css-extract-plugin
module.exports = {"card":"LandingPageCard_card__JGArT"};